import request from './request'
import type { RequestParams, ResultClass } from './types'

const dApi = 'api'
// const dHost = 'https://app.jixianxueyuan.com'
const dSecure = 'secure'
const dCipher = 'c'
const dAdmin = 'admin'
const dVersion = 'v1'

function kAppHost(): string {
  // return 'http://192.168.1.138:8080';
  // return 'http://192.168.0.107:8080';
  return 'https://app.jixianxueyuan.com'
  // return LocalData.appHost;
}

export interface ApiURLConfig {
  host?: string
  name: string | null
  other?: string | null
  keyApi?: string | null
  keyCipher?: string | null
  keySecure?: string | null
  keyAdmin?: string | null
  keyVersion?: string | null
  hasHobby?: boolean
  method?: 'GET' | 'POST' | 'DELETE' | null
  isShowLoading?: boolean
  isShowNavLoading?: boolean
  isAutoHandleFailure?: boolean
  isNeedLogin?: boolean
  isShowLog?: boolean
}

export default class ApiURL {
  host: string = kAppHost()
  name: string | null = null
  other: string | null = null
  keyApi: string = dApi
  keyCipher: string = dCipher
  keySecure: string = dSecure
  keyAdmin: string | null = null
  keyVersion: string = dVersion
  hasHobby: boolean = true

  method: 'GET' | 'POST' | 'DELETE' | null = null
  isShowLoading: boolean = false
  isShowNavLoading: boolean = false
  isAutoHandleFailure: boolean = true
  isNeedLogin: boolean = false
  isShowLog: boolean = true

  constructor(name: string) {
    this.name = name
  }

  static of(name: string): ApiURL {
    return new ApiURL(name)
  }

  private copy(key: string | null, value: unknown): ApiURL {
    const api = new ApiURL(this.name || '')
    api.host = this.host
    api.other = this.other
    api.keyApi = this.keyApi
    api.keyCipher = this.keyCipher
    api.keySecure = this.keySecure
    api.keyAdmin = this.keyAdmin
    api.keyVersion = this.keyVersion
    api.hasHobby = this.hasHobby
    api.method = this.method
    api.isShowLog = this.isShowLog
    api.isNeedLogin = this.isNeedLogin
    api.isShowLoading = this.isShowLoading
    api.isShowNavLoading = this.isShowNavLoading
    api.isAutoHandleFailure = this.isAutoHandleFailure

    if (key) {
      (api as any)[key] = value
    }
    return api
  }

  setGET(): ApiURL {
    return this.copy('method', 'GET')
  }

  setPOST(): ApiURL {
    return this.copy('method', 'POST')
  }

  setDELETE(): ApiURL {
    return this.copy('method', 'DELETE')
  }

  setOther(other: string | null): ApiURL {
    return this.copy('other', other == null ? null : `${other}`)
  }

  noHobby(): ApiURL {
    return this.copy('hasHobby', false)
  }

  noSecure(): ApiURL {
    return this.copy('keySecure', null)
  }

  setAdmin(): ApiURL {
    return this.copy('keyAdmin', dAdmin)
  }

  noCipher(): ApiURL {
    return this.copy('keyCipher', null)
  }

  appendParam(key: string, value: string): ApiURL {
    const name = `${this.name}?${key}=${value}`
    return this.copy('name', name)
  }

  showNavLoading(): ApiURL {
    return this.copy('isShowNavLoading', true)
  }

  showLoading(): ApiURL {
    return this.copy('isShowLoading', true)
  }

  noAutoHandleFailure(): ApiURL {
    return this.copy('isAutoHandleFailure', false)
  }

  needLogin(): ApiURL {
    return this.copy('isNeedLogin', true)
  }

  noLog(): ApiURL {
    return this.copy('isShowLog', false)
  }

  request(params: RequestParams = {}): Promise<ResultClass<unknown>> {
    return request.request(this, params)
  }

  URLString(): string {
    let string = this.host
    if (this.keyCipher != null) {
      string = string + `/${this.keyCipher}`
    }
    if (this.keyApi != null) {
      string = string + `/${this.keyApi}`
    }
    if (this.keySecure != null) {
      string = string + `/${this.keySecure}`
    }
    if (this.keyAdmin != null) {
      string = string + `/${this.keyAdmin}`
    }
    if (this.keyVersion != null) {
      string = string + `/${this.keyVersion}`
    }
    if (this.hasHobby) {
      string = string + `/skateboard`
    }
    string = string + '/' + this.name
    if (this.other != null) {
      string = string + `/${this.other}`
    }
    return string
  }
}
